// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyMailSendSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#technology-mail-send-solid_svg__a)">
      <mask
        id="technology-mail-send-solid_svg__b"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M24 24H0V0h24z"
        />
      </mask>
      <g mask="url(#technology-mail-send-solid_svg__b)">
        <path
          fill="currentColor"
          d="M21.803 2.096a1 1 0 0 1 .24 1.05l-6.817 19.018c-.47 1.309-2.313 1.33-2.812.032l-2.418-6.285a.5.5 0 0 1 .092-.51L20.266 3.87 8.443 13.98a.5.5 0 0 1-.505.087l-5.97-2.296C.68 11.275.686 9.453 1.975 8.966l18.773-7.092a1 1 0 0 1 1.054.222z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="technology-mail-send-solid_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTechnologyMailSendSolid;
